import styled from 'styled-components';

import {colors, fonts} from '../../styles/global';

export const MaintenancePageContent = styled.div`
  padding: 70px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  overflow: hidden;
  position: relative;

  text-align: center;
  font-family: ${fonts.justSans};
  color: ${colors.darkBlue};

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 16px;
  }

  a {
    span {
      color: ${colors.orange};
    }
  }
`;
